import React from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import { ThemeProvider } from "@/components/ThemeProvider";
import { SiteLayout } from "@/components/SiteLayout";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ContactPage from "@/pages/ContactPage";
import RequestQuotePage from "@/pages/RequestQuotePage";
import NotFoundPage from "@/pages/NotFoundPage";
import { ApplicationsPage, QualityPage } from "@/pages/OtherPages";

const QuoteRoute = () => {
  const location = useLocation();
  return <RequestQuotePage locationState={location.state} />;
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:categoryId" element={<CategoryPage />} />
            <Route path="/product/:categoryId/:productSlug" element={<ProductDetailPage />} />
            <Route path="/applications" element={<ApplicationsPage />} />
            <Route path="/quality" element={<QualityPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/request-quote" element={<QuoteRoute />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
